<template>
  <div id="app" :class="{ 'is-official': isOfficial, 'is-admin': isAdmin }">
    <!-- 回到顶部（官网前台使用自带返回顶部按钮，后台/登录页保留 element-ui 组件） -->
    <el-backtop v-if="!isOfficial && !isAdmin" :bottom="60"></el-backtop>
    <!-- 路由 -->
    <router-view/>
  </div>
</template>

<script>
import { isAdminRoute } from '@/constants/admin'

export default {
  computed: {
    isOfficial() {
      const p = this.$route.path
      return !isAdminRoute(p) && p !== '/login' && p !== '/register'
    },
    isAdmin() {
      return isAdminRoute(this.$route.path)
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  overflow-x: hidden;
  max-width: 100%;
}

#app.is-admin {
  padding: 0 !important;
  height: 100vh;
  overflow: hidden;
}

body.login-page {
  padding-top: 0;
}

/* 登录页保留边距；官网/后台全宽展示 */
@media screen and (max-width: 768px) {
  #app:not(.is-official):not(.is-admin) {
    padding: 10px;
  }
}

@media screen and (max-width: 480px) {
  #app:not(.is-official):not(.is-admin) {
    padding: 5px;
  }
}
</style>
